<template>
  <div class="p-4">
    <HeaderDetailItemSR
      :selectedItem="selectedItem"
      :optionsTaskType="optionsTaskType"
      :optionsDepartment="optionsDepartment"
      :optionsCategory="optionsCategory"
      :optionsClassification="optionsClassification"
      :optionsCause="optionsCause"
      :optionsKindTask="optionsKindTask"
    />
    <b-row>
      <b-col lg="12" class="mt-4">
        <CustomNav :items="tabs" @item-click="(val) => (activeTab = val)" />
      </b-col>
      <b-col lg="12" class="mt-3">
        <template v-if="activeTab == 1">
          <ListInternalManPower
            :data="selectedItem?.internal_manpower"
            :formRepairId="selectedItem.id"
          />
        </template>
        <template v-if="activeTab == 2">
          <ListSubContractor :data="selectedItem?.subcons" />
        </template>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CustomNav from '@/src/components/global/CustomNav.vue'
import ListInternalManPower from './ListInternalManPower.vue'
import ListSubContractor from './ListSubContractor.vue'
import HeaderDetailItemSR from './HeaderDetailItemSR.vue'

export default {
  name: 'DetailItemSR',
  props: {
    selectedItem: {
      type: Object,
      default: () => {},
    },
    optionsTaskType: {
      type: Array,
      default: () => [],
    },
    optionsDepartment: {
      type: Array,
      default: () => [],
    },
    optionsCategory: {
      type: Array,
      default: () => [],
    },
    optionsClassification: {
      type: Array,
      default: () => [],
    },
    optionsCause: {
      type: Array,
      default: () => [],
    },
    optionsKindTask: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CustomNav,
    ListInternalManPower,
    ListSubContractor,
    HeaderDetailItemSR,
  },
  data() {
    return {
      activeTab: 1,
      tabs: [
        { label: 'Internal Man Power', value: 1 },
        { label: 'Sub Contractor', value: 2 },
      ],
    }
  },
}
</script>
